export default function DuplicateRumbleIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
    >
      <g clipPath='url(#clip0_513_1756)'>
        <path
          d='M3.66764 4.99984H2.00098V16.6665C2.00098 17.5832 2.75098 18.3332 3.66764 18.3332H15.3343V16.6665H3.66764V4.99984ZM17.001 1.6665H7.00098C6.08431 1.6665 5.33431 2.4165 5.33431 3.33317V13.3332C5.33431 14.2498 6.08431 14.9998 7.00098 14.9998H17.001C17.9176 14.9998 18.6676 14.2498 18.6676 13.3332V3.33317C18.6676 2.4165 17.9176 1.6665 17.001 1.6665ZM16.1676 9.1665H12.8343V12.4998H11.1676V9.1665H7.83431V7.49984H11.1676V4.1665H12.8343V7.49984H16.1676V9.1665Z'
          fill='#408558'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_1756'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(0.333984)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
